import React from 'react';
import PropTypes from 'prop-types';

import '../styles/SetCancelMenu.css';
import MenuHeader from './MenuHeader';

const SetCancelMenu = ({ name, settings, parentName, title, index }) => {
    const currentOptionIndex = index;
    const buttonClassName = currentOptionIndex === -1 ? 'Set-button Button-active' : 'Set-button';
    return (
      <>
        <MenuHeader itemName={name} parentItemName={parentName} />
        <div className="Set-cancel-container">
          <div className="Set-cancel-title">{title}</div>
          <div className="Set-cancel-options-container">
            {settings.map((option, index) => {
              const itemClassName = index === currentOptionIndex ? 'Set-cancel-option-item Set-cancel-option-item-active' : 'Set-cancel-option-item';
              return <div key={index} className={itemClassName}>{option}</div>;
            })}
            <div className={buttonClassName}>Set</div>
          </div>
          <div className="Set-cancel-button">Cancel</div>
          </div>
      </>
    );
  };
  
SetCancelMenu.propTypes = {
  name: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  parentName: PropTypes.string,
  title: PropTypes.string,
  settings: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default SetCancelMenu;